import { createSlice } from '@reduxjs/toolkit'


const glossary = createSlice({
    name: 'glossary',
    initialState: {
        dataTypes: []
    },
    reducers: {
        // getDataTypes: ( state, action ) => {
        //     let url = 'https://api-ganymede2.interactive1.hr/data-type/list';
        //         axios.get(url)
        //         .then(res => {
        //             if (res.status === 200) {
        //                 console.log("res", res);
        //                 return res.data;
        //             }
        //             throw res;
        //         })
        //         .then(data => {
        //             console.log("dataTypes", data.data)
        //         })
        //         .catch(error => {
        //             console.log("error ", url, error);
        //         });
        //     //state.dataTypes = action.dataTypes
        // },
    }
})

export const getDataType = ( state ) => state.glossary.dataTypes

export default glossary
